const apiHeaders = {
    Accept: 'application/json'
};

export class RoleService {
    constructor($http, $q, apexApiUrl, localeService) {
        'ngInject';
        this.$http = $http;
        this.$q = $q;
        this.apexApiUrl = apexApiUrl;
        this.localeService = localeService;
    }

    retrieveRoles() {
        return this.$http.get(this.apexApiUrl + "roles/", { headers: { Accept: "application/json" } })
            .then(response => response.data);
    }

    /**
     * Retrieve a list of all roles available on the site.
     */
    retrieveV2Roles() {
        const translator = this._descriptionTranslator();
        const roles = this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/v2/roles`,
            headers: apiHeaders
        }).then(response => response.data);
        return this.$q.all([roles, translator])
            .then(([roles, translate]) => {
                for (const role of roles) {
                    translate(role);
                }
                return roles;
            });
    }

    retrieveV2Role(roleID) {
        const translator = this._descriptionTranslator();
        const role = this.$http({
            method: "GET",
            url: this.apexApiUrl + "v2/roles/" + roleID,
            headers: apiHeaders
        })
            .then(function (response) {
                return response.data;
            });
        return this.$q.all([role, translator])
            .then(([role, translate]) => translate(role));
    }

    updateRoleV2(roleID, request) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "v2/roles/" + roleID,
            data: request
        })
            .then(function (response) {
                return response.data;
            });
    }
    createRoleV2(request) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "v2/roles",
            data: request
        })
            .then(function (response) {
                return response.data;
            });
    }
    deleteRoleV2(roleID) {
        return this.$http({
            method: "DELETE",
            url: this.apexApiUrl + "v2/roles/" + roleID
        })
            .then(function (response) {
                return response.data;
            });
    }

    _descriptionTranslator() {
        return this.localeService.retrieveCurrentLocaleTranslations()
            // Resolve the translations to a function that translates a role.
            .then(translations => role => {
                if (role.Description && role.Description[0] === "|") {
                    role.TranslatedDescription = translations[role.Description.slice(1)];
                } else {
                    role.TranslatedDescription = role.Description;
                }
                return role;
            });
    }
}
